import { useEffect, useRef } from 'react';
import { useDateRange, type DateRange } from './dateFilter';

/** Date filter for dashboard drill-downs — seeds from overview range once on open. */
export function useDashboardDetailDates(initial?: DateRange) {
  const dr = useDateRange('all');
  const seeded = useRef(false);

  useEffect(() => {
    if (seeded.current) return;
    if (!initial?.start && !initial?.end) return;
    if (initial.start) dr.setStart(initial.start);
    if (initial.end) dr.setEnd(initial.end);
    dr.setPreset('custom');
    seeded.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- seed once from overview range
  }, []);

  return dr;
}
